import { MESSAGES } from '../constants/messages';

export const fetchNotaHtml = async (query) => {
  const baseUrl = import.meta.env.VITE_API_URL;
  const response = await fetch(`${baseUrl}/api/nota?search=${encodeURIComponent(query)}`);
  
  if (!response.ok) {
    throw new Error(MESSAGES.NOTE_NOT_FOUND);
  }
  
  const htmlContent = await response.text();
  
  if (!htmlContent || htmlContent.trim() === '') {
    throw new Error(MESSAGES.NOTE_NOT_FOUND);
  }
  
  return htmlContent; // Devuelve el HTML como string
};